import { Button, Menu } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import { Fragment, type ReactNode } from 'react';
import { PageActions } from './page-actions';
import { tr } from '../lib/i18n';

export type ActionMenuItem = {
  label: ReactNode;
  icon?: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  hidden?: boolean;
  danger?: boolean;
  dividerBefore?: boolean;
};

type Props = {
  label?: string;
  items?: ActionMenuItem[];
  children?: ReactNode;
};

/** Page actions as one dropdown next to the title. */
export function PageActionsMenu({ label = tr('إجراءات', 'Actions'), items = [], children }: Props) {
  const visible = items.filter((i) => !i.hidden);
  if (visible.length === 0 && !children) return null;
  return (
    <PageActions>
      <Menu position="bottom-end" width={240}>
        <Menu.Target>
          <Button variant="default" rightSection={<IconChevronDown size={14} />}>{label}</Button>
        </Menu.Target>
        <Menu.Dropdown>
          {visible.map((item, i) => (
            <Fragment key={i}>
              {item.dividerBefore && <Menu.Divider />}
              <Menu.Item leftSection={item.icon} disabled={item.disabled} color={item.danger ? 'red' : undefined} onClick={item.onClick}>
                {item.label}
              </Menu.Item>
            </Fragment>
          ))}
          {children}
        </Menu.Dropdown>
      </Menu>
    </PageActions>
  );
}
